export default class Configuration {

    constructor(env) {
        this.PRODUCTION = env.VUE_APP_PRODUCTION;
        this.API_URL = env.VUE_APP_API;
        this.APP_URL = env.VUE_APP_URL;
        this.CLIENT_ID = env.VUE_APP_CLIENT_ID;
        this.PERMISSIONS = env.VUE_APP_CLIENT_PERMISSIONS;
        this.EXTERNAL_AUTH = env.VUE_APP_EXTERNAL_AUTH;
        this.LOGIN_URL = this.EXTERNAL_AUTH + "?response_type=token&state=login&client_id=" + this.CLIENT_ID + this.PERMISSIONS + "&redirect_uri=" + this.APP_URL;
    }
  
  }